import { InjectionToken } from '@angular/core';

/**
 * Which portal mounted the donate hub (SUN-1033) — mirrors CHARITY_DETAIL_ROUTE_CONTEXT
 * (shared/pages/charity/charity-detail.facade.ts). Factory defaults to 'user' so every
 * route/consumer that never provides the token keeps today's user-portal behavior unchanged.
 *
 * Deliberately its own file, not part of donate-hub.page.ts: app-routing.module.ts needs this
 * token eagerly (route config is bootstrapped synchronously) but must NOT eagerly import the page
 * component itself — DonateHubPage pulls in DonationModalComponent, DonationAmountPadComponent,
 * and CharityPickerComponent, and a static import from the lazy-loaded module defeats
 * `loadComponent()`'s code-splitting, inlining the whole donate feature into the initial bundle.
 * Same reason CHARITY_DETAIL_ROUTE_CONTEXT lives in charity-detail.facade.ts rather than
 * charity.page.ts.
 */
export type DonateHubRouteContext = 'user' | 'business';

export const DONATE_HUB_ROUTE_CONTEXT: InjectionToken<DonateHubRouteContext> = new InjectionToken<DonateHubRouteContext>(
  'DONATE_HUB_ROUTE_CONTEXT',
  { factory: () => 'user' },
);
